import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Image from 'next/image';
import styles from './post-page-intro.module.css';
import Calendar from '../../public/svg/calendar.svg';
import Time from '../../public/svg/time.svg';
import { Container, ContainerFluid } from '../../components';

export interface PostIntroProps {
  title: string;
  background: string;
  time: number;
  date?: string;
  authorAvatar: string;
  authorName: string;
  authorPosition: string;
}

export default function PostPageIntro({
  title,
  background,
  time,
  date = '12 Jun 2022',
  authorAvatar,
  authorName,
  authorPosition,
}: PostIntroProps) {
  const [imageSize, setImageSize] = useState(1920);
  const [imageH, setImageH] = useState(550);

  const isMob = useMediaQuery({
    query: '(max-width: 450px)',
  });

  const isTab = useMediaQuery({
    query: '(max-width: 768px)',
  });

  useEffect(() => {
    setImageSize(1920);
    setImageH(550);
    if (isTab) {
      setImageSize(720);
      setImageH(550);
    }
    if (isMob) {
      setImageSize(720);
      setImageH(1040);
    }
  }, [isMob, isTab]);

  return (
    <ContainerFluid>
      <section className={styles.intro} style={{ minHeight: '220px' }}>
        <div className={styles.intro__background} />
        {background && (
          <Image
            alt={title}
            src={background}
            width={imageSize}
            height={imageH}
            className={styles.img}
            objectFit="cover"
          />
        )}

        <div className={styles.content}>
          <Container>
            <div className={styles.wrapper}>
              <h1 className={styles.intro__title}>{title}</h1>
              <div className={styles['row-full']}>
                <div className={styles.row}>
                  <div className={styles.date}>
                    <Calendar />
                    <p className={styles.text}>{date}</p>
                  </div>
                  <div className={styles.time}>
                    <Time />
                    <p className={styles.text}>{time} min</p>
                  </div>
                </div>

                <div className={styles.author}>
                  <div className={styles.avatar}>
                    <Image
                      alt={authorAvatar}
                      src={authorAvatar}
                      width={66}
                      height={66}
                      objectFit="cover"
                    />
                  </div>
                  <div className={styles.data}>
                    <p className={styles.text}>{authorName}</p>
                    <p className={styles.position}>{authorPosition}</p>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </section>
    </ContainerFluid>
  );
}
